import {
  Avatar,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useState } from "react";
import { GifColors } from "../../../theme";
// import StyledTableCell from "../../researchAuthorities/Components/Tables/StyledTableCell";
// import StyledTableRow from "../../researchAuthorities/Components/Tables/StyledTableRow";
// import SalimPic from "../static/Images/salim.jpg";
// import BobPic from "../static/Images/bob.jpg";
import StarsIcon from "@mui/icons-material/Stars";
import { useSelector } from "react-redux";
import { committeeSelector } from "../../../store/advisorSlice";
import service from "../Helpers/gifservices";
import { useLoading } from "../../../providers/loadingProvider";
import AddPhoto from "../Components/AddPhoto";
import { useNotify } from "../../../providers/NotificationProvider";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  button: {
    "&:hover": {
      backgroundColor: GifColors.darkBlue,
    },
    color: "#FFFFFF",
    backgroundColor: GifColors.israelBlue,
  },
  photo: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    margin: "0 auto 0 auto",
    cursor: "pointer",
  },
  chairIcon: {
    marginLeft: 5,
    position: "relative",
    top: 8,
  },
}));

const MemberRow = (props) => {
  const { member, refreshProposals } = props;
  const loading = useLoading();
  const notify = useNotify();
  const classes = useStyles();
  const [photoModalOpen, setPhotoModalOpen] = useState(false);

  const uploadPhoto = async (photo) => {
    const loadingId = loading.addLoading("Uploading Photo");
    await service.UploadContactImage({
      file: photo,
      contactId: member.contact.contactId,
    });
    setPhotoModalOpen(false);
    loading.removeLoading(loadingId);
    refreshProposals();
    notify.show("Uploading photo completed successfully");
  };

  const mailTo = (email) => {
    window.location = `mailto:${email}`;
  };

  return (
    <>
      <AddPhoto
        open={photoModalOpen}
        onClose={() => setPhotoModalOpen(false)}
        uploadPhoto={uploadPhoto}
        image={`data:image/png;base64, ${member.image}`}
      />
      <TableRow key={member.advisorID}>
        <TableCell>
          {member.advisorName}
          {member.isCommitteeCoordinator && (
            <Tooltip title="Panel Chair">
              <StarsIcon color="primary" className={classes.chairIcon} />
            </Tooltip>
          )}
        </TableCell>
        <TableCell>
          <Link
            underline="hover"
            to="#"
            onClick={() => mailTo(member.contact.primaryEmail)}
          >
            {member.contact.primaryEmail}
          </Link>
        </TableCell>
        {/* <TableCell>{member.contact.websiteurl}</TableCell> */}
        <TableCell>
          <a href={member.contact.websiteurl}> {member.contact.websiteurl}</a>
        </TableCell>
        <TableCell>{member.contact.phoneHome}</TableCell>
        <TableCell>
          {member.image ? (
            <Avatar
              variant="rounded"
              alt={member.name}
              src={`data:image/png;base64, ${member.image}`}
              className={classes.photo}
              onClick={() => setPhotoModalOpen(true)}
            ></Avatar>
          ) : (
            <Button
              className={classes.button}
              size="small"
              onClick={() => setPhotoModalOpen(true)}
            >
              + Add Photo
            </Button>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export default function PanelMembers() {
  const loading = useLoading();
  const committee = useSelector(committeeSelector);
  const [members, setMembers] = useState([]);
  const [firstLoadingId, setFirstLoadingId] = useState(null);

  const tableHeaders = [
    { label: "Full Name", width: "15%" },
    { label: "Email", width: "30%" },
    { label: "Website", width: "20%" },
    { label: "Telephone", width: "15%" },
    { label: "Photo", width: "10%" },
  ];

  const getCommitteeMembers = useCallback(async () => {
    if (!committee) return;
    const loadingId = loading.addLoading("Loading Panel");
    const committeeId = committee.committeeId;
    let members = await service.GetCommitteeAdvisors({ committeeId });
    members = await getAdvisorImages(members);
    setMembers(members);
    loading.removeLoading(loadingId);
  }, [committee, loading]);

  const getAdvisorImages = async (members) => {
    var contactsIds = members.map((c) => c.contact.contactId);
    var contactsImages = await service.GetContactsImages({ contactsIds });
    if (!contactsImages || contactsImages.length === 0) return;
    let updatesMembers = members;
    updatesMembers.forEach((member) => {
      var memberImage = contactsImages[member.contact.contactId];
      if (memberImage) member.image = memberImage;
    });
    return updatesMembers;
  };

  useEffect(() => {
    getCommitteeMembers();
  }, [getCommitteeMembers]);

  useEffect(() => {
    if (firstLoadingId === "Done") return;
    if (!committee) {
      if (firstLoadingId === null) {
        setFirstLoadingId(loading.addLoading("Loading Committee"));
      }
    } else {
      if (firstLoadingId) {
        loading.removeLoading(firstLoadingId);
      }
      setFirstLoadingId("Done");
    }
  }, [committee, loading, firstLoadingId]);

  return (
    <Box bgcolor="#FBFAFA" paddingBottom={2} paddingTop={1}>
      <Table>
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell key={header.label} style={{ width: header.width }}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {members.map((member) => (
            <MemberRow
              key={member.advisorID}
              member={member}
              refreshProposals={getCommitteeMembers}
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
